module.exports = __webpack_public_path__ + "static/media/U volume.d08eab27.kra";